import { InfoSection } from '@components'

import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { DE_AUTHORITY_URL } from '../../../../consts/taxAuthoritiesUrls'

export const ModalBodyDE = (): ReactElement => {
  const { t } = useTranslation()

  const infoText = (
    <Trans i18nKey="vat_declarations.settlement_modal.modal_body.body_info_de" value="test">
      Please note that you must submit the figures to BZSt yourself via
      <Link href={DE_AUTHORITY_URL} target="_blank" rel="noreferrer">
        ELSTER
      </Link>
    </Trans>
  )

  return (
    <>
      <Text>{t('vat_declarations.settlement_modal.modal_body.body_text_de')}</Text>
      <InfoSection infoText={infoText} />
    </>
  )
}
